import '../Sass/App.scss';

export function Instruction(props) {

    function editInstruction() {
        props.modifyHandler(props.data.instruction_id, true);
    }

    return (
        <li>
            <b>{props.data.name}</b>
            { props.editable && <>
                <button onClick={editInstruction} className="il-button">edit</button>
            </>}
            <br/>
            {props.data.description}
        </li>
    )
}